import { useGetApiWorkspaceGetPublicInfo } from "@/API";
import { Box, Group, Text, LoadingOverlay, Pagination, Flex, Button, ActionIcon, Breadcrumbs, Divider, Center, Stack, Card, Alert, } from "@mantine/core";
import { RequestWorkspaceAuthButton } from "./RequestWorkspaceAuthButton";
import { IconInfoCircle, IconLogin, IconUserShare } from "@tabler/icons-react";
import { useAuthStore } from "@/Stores/AuthStore";
import { useMemo, useState } from "react";
import { LoginButton } from "@/Auth/LoginPage";

export function WorkspaceNoPermissionPage(props: { workspaceId: string, status: number }) {
    const auth = useAuthStore()
    const isLogin = useMemo(() => {
        return !!auth.data.userName;
    }, [auth.data.userName])
    const workspacePublicInfo = useGetApiWorkspaceGetPublicInfo({ id: props.workspaceId })
    return <Box pos="relative">
        <LoadingOverlay visible={workspacePublicInfo.isLoading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} loaderProps={{ type: 'bars', size: "sm" }} />
        {props.status == 404 ? <>
            <Text c="gray" size="40px" ta="center">
                工作空間不存在
            </Text>
        </> : props.status == 401 || !isLogin ? <>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
                <Stack gap={5} align="center">
                    <Text size="xl" fw={500}>{workspacePublicInfo.data?.data.name}</Text>
                    <Text size="sm">
                        擁有者:{`${workspacePublicInfo.data?.data.ownerUserName}`}{workspacePublicInfo.data?.data.ownerUserDisplayName ? `(${workspacePublicInfo.data?.data.ownerUserDisplayName})` : ""}
                    </Text>
                    <br />
                    <Stack gap={0} align="center">
                        <Text size="sm">
                            無法存取此頁面
                        </Text>
                        <Text size="sm">
                            如果管理者批准你的請求，則可以存取此頁面
                        </Text>
                    </Stack>
                    <Text c="gray" size="sm">
                        {isLogin ? <>
                            目前登入帳號：{`${auth.data.userName}`}{auth.data.displayName ? `(${auth.data.displayName})` : ""}
                        </> : <>
                            目前登入帳號：未登入
                        </>}
                    </Text>
                </Stack>
                {isLogin ?
                    <RequestWorkspaceAuthButton workspaceId={props.workspaceId}  >
                        {({ isRequested, isLoading, request }) => (<>
                            {auth.data.role == "user" ? <>
                                <Button loading={isLoading} disabled={isRequested} onClick={request} fullWidth mt="md" radius="md" >
                                    <Text size="sm">
                                        {isRequested ? "已發出請求" : "請求權限"}
                                    </Text>
                                </Button>
                            </> : <>
                                <Alert mt="sm" variant="light" color="yellow" title="只有使用者可以加入工作空間" icon={<IconInfoCircle />} />
                            </>}
                        </>)
                        }
                    </RequestWorkspaceAuthButton>
                    : <>
                        <Text c="gray" size="lg" mt="md" ta="center">
                            請先
                            <LoginButton onLogin={() => {
                                window.location.reload();
                            }}>
                                {
                                    ({ opened, open }) =>
                                        <span onClick={open} style={{ cursor: "pointer", color: "var(--mantine-primary-color-filled)" }}>登入</span>
                                }
                            </LoginButton>
                            後再嘗試
                        </Text>
                    </>}
            </Card>
        </> : <>
        </>}
    </Box>
}